import { Link } from 'react-router';

export function ProFooter() {
  return (
    <footer className="bg-[#fcfcfc] border-t border-[#eee] py-8 mt-auto">
      <div className="max-w-[1440px] mx-auto px-6 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-6 text-[14px] text-[#908e8e]">
          <span>© {new Date().getFullYear()} All rights reserved</span>
          <Link to="/privacy-policy" className="hover:text-[#3a3335]">Privacy Policy</Link>
          <Link to="/terms-of-use" className="hover:text-[#3a3335]">Term of Use</Link>
        </div>
        <div className="flex items-center gap-6 text-[14px] text-[#908e8e]">
          <div className="flex items-center gap-1">
            <span className="material-icons text-[18px]">public</span>
            <span>English</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="material-icons text-[18px]">more_horiz</span>
            <span>GBP</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
